// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3cqDe","backBtn":"styles_backBtn__3l0Od","box":"styles_box__2X16q"};